import React, { useEffect } from 'react';
import '@/App.css';
import { Instagram } from 'lucide-react';

function App() {
  useEffect(() => {
    document.title = 'Spice Pilates';
  }, []);

  return (
    <div className="App min-h-screen bg-[#F8F6F0] flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center space-y-8">
        {/* Logo / Studio Name */}
        <h1
          data-testid="studio-name"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-[#7A1C30] tracking-tight"
        >
          Spice Pilates Studio
        </h1>

        {/* Divider */}
        <div className="w-16 h-[2px] bg-[#7A1C30] mx-auto"></div>

        {/* Main Message */}
        <div className="space-y-4">
          <h2
            data-testid="maintenance-heading"
            className="font-serif text-2xl sm:text-3xl text-[#2D1B1E] tracking-tight"
          >
            We're Rebuilding
          </h2>
          <p
            data-testid="maintenance-message"
            className="font-sans text-base md:text-lg leading-relaxed text-[#5C4A4D] max-w-lg mx-auto"
          >
            We are currently rebuilding our system and as we do, our studio is temporarily closed.
          </p>
        </div>

        {/* Contact Section */}
        <div className="space-y-4 pt-4">
          <p className="font-sans text-sm text-[#5C4A4D]">
            If you have questions, please message us on Instagram
          </p>
          <a
            href="https://www.instagram.com/spicepilatesph/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-link"
            className="inline-flex items-center justify-center space-x-3 rounded-full bg-[#7A1C30] text-[#F8F6F0] hover:bg-[#5C1322] transition-all duration-300 px-8 py-4 text-sm font-medium tracking-wide uppercase"
          >
            <Instagram size={20} />
            <span>@spicepilatesph</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
